

















































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import CloseButton from "@/components/buttons/close-button.vue";
import SubmitResetButtonGroop from "@/components/buttons/submit-reset-button-groop.vue";
import UploadingImageToServer from "@/components/app/images/uploading-image-to-server.vue";
import ChangeDeliteButtons from "@/components/buttons/change-delite-buttons.vue";
import BSwitch from "@/components/app/switchs/b-switch.vue";
import UploadPicture from "@/components/app/images/upload-picture.vue";

import MainDemo from "@/components/demo/main-demo.vue";
import AlertMailDemo from "@/components/demo/mails/alert-mail-demo.vue";
import ButtonLocales from "@/components/buttons/button-locales.vue";
import HorizontalList from "@/components/app/list/horizontal-list.vue";
import StandertIconsGroup from "@/components/app/images/group/standert-icons-group.vue";

import { VueEditor } from "vue2-editor";
import { Hooper, Slide } from "hooper";

import { IAlertState as IAlert } from "@/@types/speciaMessage/speciaMessage";
import { ILocale } from "@/@types/locale";
import { pics } from "@/config/host.config";
import { deleteImages } from "@/api/delite/delite-element";
import { getAdminPermition } from "@/services/accessDecoder";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({
  components: {
    StandartModal,
    Slide,
    Hooper,
    BSwitch,
    MainDemo,
    VueEditor,
    CloseButton,
    ButtonLocales,
    AlertMailDemo,
    UploadPicture,
    HorizontalList,
    "icons-group": StandertIconsGroup,
    ChangeDeliteButtons,
    UploadingImageToServer,
    submit: SubmitResetButtonGroop,
  },
})
export default class MessageAlertForm extends Vue {
  @Prop({ type: String, default: "" }) manager_id!: string;
  @Prop({ type: String, default: "" }) active_type!: string;
  @Prop({ type: Object, default: null }) item!: IAlert;

  types = ["birthday", "hello"];
  type = "";

  folder = "global/mail/backgrounds";
  iconFolder = "global/mail/icons";
  staticForm = false;
  showModal = false;

  locale = this.$store.getters.getLanguages[0];
  variant = "primary";
  background = "";
  icon = "";

  name = "";
  names: ILocale = {};
  description = "";
  descriptions: ILocale = {};
  title = "";

  icons: string[] = [];
  backgrounds: string[] = [];

  date: string | Date | null = null;

  get canManageImages(): boolean {
    return this.$isRoot() || getAdminPermition();
  }

  get alert(): IAlert {
    return {
      _id: this.item ? this.item._id : "",
      show: this.item ? this.item.show : false,
      value: this.names,
      title: this.title,
      type: this.type ? this.type : this.active_type,
      current:
        this.type == "hello" || this.type == "birthday" ? true : undefined,
      description: this.descriptions,
      date: this.date,
      manager_id: this.manager_id,
      variant: this.variant,
      src: {
        background: this.background,
        icon: this.icon,
      },
    };
  }

  setToday(): void {
    const now = new Date();
    this.date = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  }

  @Watch("name")
  updatename(): void {
    this.names[this.locale] = this.name;
  }

  @Watch("description")
  updatedescription(): void {
    this.descriptions[this.locale] = this.description;
  }

  @Watch("locale")
  changeItemParams(): void {
    if (this.names)
      this.name = this.names[this.locale] ? this.names[this.locale] : "";
    else this.name = "";
    if (this.descriptions)
      this.description = this.descriptions[this.locale]
        ? this.descriptions[this.locale]
        : "";
    else this.description = "";
  }

  onSubmit(event: Event): void {
    event.preventDefault();
    this.$emit("sawe", this.alert._id, this.alert);
  }

  onReset(): void {
    this.name = "";
    this.description = "";
    this.date = new Date();
    this.manager_id = "";
    this.variant = "primary";
    this.background = "";
    this.icon = "";
    this.names = {};
    this.descriptions = {};
    this.type = "";
    this.title = "";
  }

  @Watch("item")
  init(): void {
    this.showModal = false;
    setTimeout(() => (this.showModal = true), 100);
    if (!this.item) return;
    this.names = this.item.value;
    this.type = this.item.type ? this.item.type : this.active_type;
    this.descriptions = this.item.description;
    this.date = this.item.date;
    this.variant = this.item.variant;
    this.background = this.item.src.background;
    this.icon = this.item.src.icon;
    this.title = this.item.title;
    this.changeItemParams();
  }

  async deliteImage(image: string, folder: string): Promise<void> {
    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("main.confirms.ok")),
        { title: "Delete image?" }
      );

      if (result === true) {
        deleteImages(image, folder).then(() => {
          this.getBgs();
          this.getIcons();
        });
      }
    } catch {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  imageChoice(image: string): void {
    this.background = image;
  }

  async getBgs(): Promise<void> {
    const url = pics.download;
    const params = { path: this.folder + "/origin" };
    try {
      const res = await this.$axios.get(url, { params });

      if (res.status === 200) {
        this.backgrounds =
          res.data == "Папка не найдена" || res.data == "Папка пуста"
            ? []
            : res.data;
      }
    } catch (error) {
      console.log(error);
    }
  }

  async getIcons(): Promise<void> {
    const url = pics.download;
    const params = { path: this.iconFolder };
    try {
      const res = await this.$axios.get(url, { params });

      if (res.status === 200) {
        this.icons =
          res.data == "Папка не найдена" || res.data == "Папка пуста"
            ? []
            : res.data;
      }
    } catch (error) {
      console.log(error);
    }
  }

  mounted(): void {
    this.getBgs();
    this.getIcons();
  }
}
